import { useTranslations } from 'next-intl'

import { RoomCount } from '@/entities/map'
import { useMultiScrollState } from '@/shared/lib'

import { Filter, useFilter } from '../../model/filter'
import { Title, List, Item } from '../common/layout'

const useRoomCounts = () => {
  const t = useTranslations('filter')

  const ROOM_COUNTS = [
    {
      title: t('room_count_one'),
      value: RoomCount.One,
    },
    {
      title: t('room_count_two'),
      value: RoomCount.Two,
    },
    {
      title: t('room_count_three_plus'),
      value: RoomCount.ThreePlus,
    },
  ]

  return { ROOM_COUNTS }
}

type Props = {
  className?: string
}

export const RoomCounts = ({ className }: Props) => {
  const t = useTranslations('filter')

  const { registerScrollElement } = useMultiScrollState<HTMLDivElement>()

  const {
    type,
    filter: { roomCounts },
    updateFilter,
  } = useFilter()

  const { ROOM_COUNTS } = useRoomCounts()

  const handleRoomCountChange = (value: RoomCount) => () => {
    updateFilter({ roomCounts: value })
  }

  return (
    <div
      className={className}
      ref={element => {
        if (element) {
          registerScrollElement(Filter.RoomCounts, element)
        }
      }}
    >
      <Title>{t('room_count.title')}</Title>
      <List>
        {ROOM_COUNTS.map(({ title, value }) => (
          <Item
            key={value}
            type={type}
            selected={roomCounts.includes(value)}
            onClick={handleRoomCountChange(value)}
          >
            {title}
          </Item>
        ))}
      </List>
    </div>
  )
}
